/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CompanyEmployerFlowItem } from './companyEmployerFlowItem';
import type { CompanyHeadcountPointSchema } from './companyHeadcountPointSchema';
import type { CompanyStatCardSchema } from './companyStatCardSchema';
import type { CompanyTopSkillSchema } from './companyTopSkillSchema';

export interface CompanyAnalyticsResponse {
  previous_employers?: CompanyEmployerFlowItem[];
  next_employers?: CompanyEmployerFlowItem[];
  headcount_over_time?: CompanyHeadcountPointSchema[];
  stats?: CompanyStatCardSchema[];
  top_skills?: CompanyTopSkillSchema[];
}
